module.exports = __webpack_public_path__ + "img/6554692.436e8081.png";